import React from 'react';
interface IntakeProps {
  children: React.ReactNode;
  className?: string;
  step: number;
  progress?: number;
}
export const CareerRoadMapHeader: React.FC<IntakeProps> = ({ children, step }) => {
  const renderIntakeHeader = () => {
    switch (step) {
      case 1:
        return (
          <div className="text-2xl p-4 text-white ">
            <span className="font-semibold"> Career Road-Map </span> ASSESSMENT
          </div>
        );
      default:
        return (
          <div className="text-2xl p-4 text-white ">
            <span className="font-semibold"> Career Road-Map </span> ASSESSMENT
          </div>
        );
    }
  };
  return (
    <div className="flex items-center justify-center w-full">
      <div
        className={`mx-auto w-full max-w-4xl bg-white-100 py-8 px-5 shadow-xl border-l border-r relative bg-white`}
      >
        <div className="mb-2 text-center theme-gradient rounded-xl">
          <>{renderIntakeHeader()}</>
          {/* <div className="w-3/4 bg-gray-200 rounded-full h-2.5 dark:bg-gray-100 m-auto relative bottom-[-5px]"></div> */}
        </div>

        <div>{children}</div>
      </div>
    </div>
  );
};
